import React, { createContext, useCallback, useContext, useState } from "react";
import WhatsAppModal from "../components/WhatsAppFlotante/WhatsAppModal";
import useFirestoreUpdate from "./useFirestoreData";
import { openWhatsAppConsulta } from "./whatsappConfig";

const WhatsAppConsultaContext = createContext(null);

export function useWhatsAppConsulta() {
  const ctx = useContext(WhatsAppConsultaContext);
  if (!ctx) {
    throw new Error("useWhatsAppConsulta debe usarse dentro de WhatsAppConsultaProvider");
  }
  return ctx;
}

export function WhatsAppConsultaProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { updateData } = useFirestoreUpdate("consultas", "validaciones");

  const openConsultaForm = useCallback(() => {
    setOpen(true);
  }, []);

  const handleModalSubmit = async (values) => {
    setLoading(true);
    try {
      await updateData(values);
      setOpen(false);
      openWhatsAppConsulta();
    } catch {
      alert("Ocurrió un error al guardar los datos. Intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <WhatsAppConsultaContext.Provider value={{ openConsultaForm, loading }}>
      {children}
      <WhatsAppModal
        open={open}
        onClose={() => setOpen(false)}
        onSubmit={handleModalSubmit}
        loading={loading}
      />
    </WhatsAppConsultaContext.Provider>
  );
}
